const iconNames = [
  "noMarker",
  "pin",
  "flag",
  "tag",
  "clip",
  "bulb",
  "star",
  "markerPresent",
  "cake",
  "markerCandle",
  "markerEgg",
  "markerTree",
  "markerClink",
  "heart",
  "markerFireworks",
  "markerLantern",
  "mortar",
  "award",
  "markerGhost",
  "markerRocket",
  "markerFlower",
  "markerMaple",
  "markerLeaf",
  "sapling",
  "sun",
  "moon",
  "markerMoon1",
  "markerMoon2",
  "markerMoon3",
  "markerMoon4",
  "markerMoon5",
  "markerMoon6",
  "markerMoon7",
  "markerMoon8",
  "markerSnow",
  "markerWind",
  "paw",
  "food",
  "pill",
  "key",
  "crown",
  "swords",
  "document",
  "mail",
  "scroll",
  "checkedBox",
  "comment",
  "comments",
  "clock",
  "hourglass",
  "infoIcon",
  "alertIcon",
  "questionIcon",
  "happy",
  "neutral",
  "unhappy",
  "markerOther"
];

export default iconNames;
